export type HsVisualQualityShadingMode = 'unlit' | 'diffuse';

export interface HsVisualQualitySettings {
  shadingMode: HsVisualQualityShadingMode;
  ambientIntensity: number;
  directionalIntensity: number;
  specularEnabled: boolean;
  specularIntensity: number;
  fresnelEnabled: boolean;
  fresnelIntensity: number;
  exposure: number;
  contrast: number;
}

export const HS_DEFAULT_VISUAL_QUALITY_SETTINGS: Readonly<HsVisualQualitySettings> = {
  shadingMode: 'diffuse',
  ambientIntensity: 0.4,
  directionalIntensity: 1,
  specularEnabled: false,
  specularIntensity: 0,
  fresnelEnabled: false,
  fresnelIntensity: 0,
  exposure: 0,
  contrast: 1,
};
